import { render, staticRenderFns } from "./ThumbnailImg.vue?vue&type=template&id=1f9f0d82&scoped=true"
import script from "./ThumbnailImg.vue?vue&type=script&lang=ts"
export * from "./ThumbnailImg.vue?vue&type=script&lang=ts"
import style0 from "./ThumbnailImg.vue?vue&type=style&index=0&id=1f9f0d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9f0d82",
  null
  
)

export default component.exports